import React from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';

const SurveyTemplateOptions = ({values, handleChange, setFieldValue, errors}) => {
  return (
    <Container>
      <Row className="mt-4">
        <Col xs={12} md={6}>
          <h6>Preguntas</h6>
          <hr className="mb-4" />
          <Form.Group>
            <Form.Row>
              <Col>
                <Form.Label className="font-weight-bold">Paginación</Form.Label>
              </Col>
              <Col>
                {  
                  ['Una página por pregunta', 
                  'Una página con todas las preguntas',
                  'Una página por sección'].map((item, index) => (
                    <Form.Check
                      className={`mb-1 ${item === 'Una página por sección' ? 'invisible' : ''}`}
                      key={index}
                      type="radio"
                      name="paginationQuestion"
                      onChange={e => setFieldValue('paginationQuestion', item)}
                      checked={item === values.paginationQuestion}
                      label={item} />
                  ))
                }
              </Col>
            </Form.Row>
          </Form.Group>
          <Form.Group className="invisible">
            <Form.Row>
              <Col>
                <Form.Label className="font-weight-bold">Mostrar progreso como</Form.Label>
              </Col>
              <Col>
                {  
                  ['Porcentaje restante', 
                   'Número',].map((item, index) => (
                    <Form.Check
                      key={index}
                      className="mb-1"
                      type="radio"
                      name="showProgressBar"
                      onChange={() => setFieldValue('showProgressBar', item)}
                      defaultChecked={(values.showProgressBar === item)}
                      label={item} />
                  ))
                }
              </Col>
            </Form.Row>
          </Form.Group>
          <Form.Group className="invisible">
            <Form.Row>
              <Col>
                <Form.Label className="font-weight-bold">Preguntas</Form.Label>
              </Col>
              <Col>
                <Form.Check
                  type="checkbox"
                  name="allowSkippingQuestions"
                  onChange={handleChange}
                  checked={values.allowSkippingQuestions}
                  label="¿Permitir saltar preguntas?" />
              </Col>
            </Form.Row>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <h6>Participantes</h6>
          <hr className="mb-4" />
          <Form.Group>
            <Form.Row>
              <Col xs={12} md={4}>
                <Form.Label className="font-weight-bold">¿Es necesario iniciar sesión?</Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <Form.Check
                  type="checkbox"
                  name="isNeededLogin"
                  onChange={handleChange}
                  checked={values.isNeededLogin} />
              </Col>
            </Form.Row>
          </Form.Group>
          {
            values.survey_type === 'Evaluación' && (
              <>
                <Form.Group>
                  <Form.Row>
                  <Col xs={12} md={4}>
                    <Form.Label className="font-weight-bold">Puntaje total</Form.Label>
                  </Col>
                  <Col xs={12} md={8}>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="1"
                      name="total_score"
                      min="1"
                      max="3"
                      onChange={handleChange}
                      value={values.total_score}
                      isInvalid={errors.total_score} />
                      <Form.Control.Feedback type="invalid">
                        {errors.total_score}
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Row>
                </Form.Group>
                <Form.Group className="invisible">
                  <Form.Row>
                    <Col xs={12} md={4}>
                      <Form.Label className="font-weight-bold">Limitar intentos</Form.Label>
                    </Col>
                    <Col xs={12} md={8}>
                      <Form.Control
                        size="sm"
                        type="number"
                        step="1"
                        name="limitAttempts"
                        min="1"
                        max="5"
                        onChange={handleChange}
                        value={values.limitAttempts}
                        isInvalid={errors.limitAttempts} />
                        <Form.Control.Feedback type="invalid">
                          {errors.limitAttempts}
                        </Form.Control.Feedback>
                    </Col>
                  </Form.Row>
                </Form.Group>
              </>
            )
          }
          <Form.Group className="invisible">
            <Form.Row>
              <Col xs={12} md={4}>
                <Form.Label className="font-weight-bold">Modo de acceso</Form.Label>
              </Col>
              <Col xs={12} md={8}>
                <Form.Control 
                  as="select" 
                  name="accessMode"
                  size="sm"
                  onChange={handleChange}
                  value={values.accessMode}
                  isInvalid={errors.accessMode}>
                  <option value="" disabled>Seleccionar</option>
                  {
                    ['Cualquier persona que tenga el enlace', 
                     'Solo personas con invitación'].map((item, index) => (
                      <option 
                        key={index} 
                        value={item}>{item}</option>
                    ))
                  }
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.accessMode}
                  </Form.Control.Feedback>
              </Col>
            </Form.Row>
          </Form.Group>
        </Col>
      </Row>
    </Container>
  )
}

export default SurveyTemplateOptions;